import React, { PureComponent } from 'react'
import { Trans } from '@lingui/react'

import subscriptionHelper from 'client/shared/helpers/subscription-helper'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'

import './readable-price.styl'

type Props = {
  price: number
  currency: string
  currencyDisplay?: string
  kind: 'short' | 'long' | 'mixed' | 'monthly'
  intlId?: string
  noSpaces?: boolean
  className: string
} & DecoratorProps

class _ReadablePrice extends PureComponent<Props> {
  static defaultProps = {
    intlId: 'plan.price_1_month', // id of the i11n message
  }

  render(): JSX.Element | null {
    const {
      kind,
      price,
      currency,
      currencyDisplay,
      intlId,
      locale,
      noSpaces,
      className,
    } = this.props

    const readablePrice = subscriptionHelper.readablePrice({
      locale,
      currency,
      currencyDisplay,
      price,
    })

    const period = intlId?.split('_').slice(-1)
    const shortPrice = noSpaces
      ? readablePrice.replace(/ /g, '')
      : readablePrice

    const priceDigit = /\d+/g.exec(shortPrice)

    switch (kind) {
      case 'short':
        return <span className={className}>{shortPrice}</span>
      case 'long':
        return (
          <Trans
            id={intlId || 'plan.price_1_month'}
            values={{ price: readablePrice }}
          />
        )
      case 'monthly':
        return (
          <Trans id="plan.price_per_month" values={{ price: readablePrice }} />
        )
      case 'mixed':
        return (
          <div className="readable-price__mixed">
            <span className="readable-price__mixed_price">
              {priceDigit && priceDigit[0]}
            </span>
            <span className="readable-price__mixed_currency">
              {currency}/{period}
            </span>
          </div>
        )
      default:
        return null
    }
  }
}

export const ReadablePrice = uiBox(_ReadablePrice)
